import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Switch } from "react-router-dom";
import React from "react";
import SEO from "../../UI/SEO/SEO";
import { getPreBaseRoute } from "../../../../components";
import OpportunityDetail from "./OpportunityDetail";
export const getOpportunityBaseRoute = () => getPreBaseRoute() + "/app/opportunity";
export const getOpportunityDetailPath = (opportunityId) => getOpportunityBaseRoute() + `/${opportunityId}`;
export const getOpportunityDetailRoute = () => getOpportunityBaseRoute() + "/:opportunityId";
const OpportunityRoutes = () => (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Opportunity" }), _jsx(Switch, { children: _jsx(Route, { component: OpportunityDetail, path: getOpportunityDetailRoute() }) })] }));
export default OpportunityRoutes;
